import Immutable from 'immutable';

export function toImmutable<T>(object: T | DeepIMap<T>): DeepIMap<T> {
  return Immutable.isImmutable(object) ? object : Immutable.fromJS(object);
}
